module.exports = __webpack_public_path__ + "img/pic_haifan_2.b3722ea4.png";